import { render, staticRenderFns } from "./BusinessMatchSavedContacts.vue?vue&type=template&id=2d7a0a7a&scoped=true"
import script from "./BusinessMatchSavedContacts.vue?vue&type=script&lang=ts"
export * from "./BusinessMatchSavedContacts.vue?vue&type=script&lang=ts"
import style0 from "./BusinessMatchSavedContacts.vue?vue&type=style&index=0&id=2d7a0a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a0a7a",
  null
  
)

export default component.exports